import React from 'react';
import { Card, Box, Typography, IconButton, Tooltip } from '@mui/material';
import XIcon from '@mui/icons-material/X'; // MUI's new X icon
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function SocialShare({ csnId }) {
    const shareUrl = `${window.location.origin}/certificate/view/${csnId}`;
    const encodedUrl = encodeURIComponent(shareUrl);

    const openShare = (platform) => {
        let url = '';
        switch (platform) {
            case 'linkedin':
                url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
                break;
            case 'x':
                url = `https://twitter.com/intent/tweet?url=${encodedUrl}`; // still works
                break;
            case 'whatsapp':
                url = `https://wa.me/?text=${encodedUrl}`;
                break;
            default:
                return;
        }
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <Card
            sx={{
                padding: '1.5rem',
                backgroundColor: '#fff',
                borderRadius: '16px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
            }}
        >
            <Typography variant="h6" fontWeight="600" mb={1}>
                Share Credential
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={3}>
                Let the world know what you've achieved!
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2 }}>
                <Tooltip title="Share on LinkedIn">
                    <IconButton onClick={() => openShare('linkedin')}>
                        <LinkedInIcon sx={{ fontSize: 30, color: '#0077B5' }} />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Share on X">
                    <IconButton onClick={() => openShare('x')}>
                        <XIcon sx={{ fontSize: 30, color: '#000' }} />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Share on WhatsApp">
                    <IconButton onClick={() => openShare('whatsapp')}>
                        <WhatsAppIcon sx={{ fontSize: 30, color: '#25D366' }} />
                    </IconButton>
                </Tooltip>
            </Box>
        </Card>
    );
}

export default SocialShare;
